import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RoleBasedRedirect: React.FC = () => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#0f1419]">
        <div className="flex flex-col items-center text-[#888]">
          <div className="w-12 h-12 border-4 border-[#089453]/10 border-t-[#089453] rounded-full animate-spin"></div>
          <p className="mt-4">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={isAdmin ? '/admin/postos' : '/postos'} replace />;
};

export default RoleBasedRedirect;

